import { multiFilter } from "@homebound/beam";
import { useMemo } from "react";
import { ReadyPlanStatus } from "src/generated/graphqlTypes";
import { useReadyPlanStatusFilterMetadataQuery } from "src/hooks/filters/readyPlanStatus/useReadyPlanStatusFilter.generated";

type UseReadyPlanStatusFilterOptions = { omitArchived?: boolean };

export function useReadyPlanStatusFilter(opts: UseReadyPlanStatusFilterOptions = {}) {
  const { omitArchived } = opts;
  const { data } = useReadyPlanStatusFilterMetadataQuery({ fetchPolicy: "cache-first" });
  const rpStatusFilter = useMemo(
    () =>
      multiFilter({
        options: (data?.enumDetails.readyPlanStatus ?? []).filter(
          (s) => !omitArchived || s.code !== ReadyPlanStatus.Archived,
        ),
        getOptionValue: (o) => o.code,
        getOptionLabel: (o) => o.name,
      }),
    // TODO: validate this eslint-disable. It was automatically ignored when the oxlint migration restored `react-hooks/exhaustive-deps` to an error.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [data, omitArchived],
  );

  return { rpStatusFilter };
}
